import { useQuery } from "@tanstack/react-query";
import { type TickerChartData } from "@bloomberg/media-ui-markets";
import { fetchHistoryChartData } from "~api/chart-data/fetchHistoryChartData";
import { SECTION_FRONT_REFRESH_INTERVAL_IN_MS } from "~constants";
import { PortfolioChartDateRange } from "~types/portfolio";
import { getChartTickerColor } from "~components/WatchlistComparisonChart/utils";
import { HistoryChartData } from "~types/types";

const transformData = (
  historyChartData: HistoryChartData[]
): TickerChartData[] => {
  const historyTickerChartData = historyChartData.map(
    ({ id, series }, index) => ({
      id,
      priceMovements:
        series.map(({ date, value }) => ({
          dateTime: date,
          value,
        })) ?? [],

      color: getChartTickerColor(index),
    })
  );

  return historyTickerChartData;
};

export const useBenchmarkComparisonData = (
  tickers: string[],
  chartType: PortfolioChartDateRange
) => {
  const tickersString = tickers.sort().join(",");

  return useQuery({
    queryKey: ["benchmark-comparisons", tickersString, chartType],
    queryFn: () => fetchHistoryChartData(tickers, chartType) ?? [],
    enabled: tickers.length > 0,
    staleTime: SECTION_FRONT_REFRESH_INTERVAL_IN_MS,
    refetchInterval: SECTION_FRONT_REFRESH_INTERVAL_IN_MS,
    select: (data) => transformData(data),
  });
};
